import React, { useEffect } from "react";
import styled from "styled-components";
import { Body2, Heading4 } from "app/popleads/components/ui-kit/Text";
import { colors } from "app/popleads/components/ui-kit/colors";
import ButtonWithText from "app/popleads/components/ui-kit/Button";
import { FormattedNumber } from "react-intl";
import ExtensionAddPayment from "./ExtensionAddPayment";
import ExtensionPaymentList from "./ExtensionPaymentList";
import { useExtensionContext } from "../ExtensionContext";
import useGetDealPaymentsByDealId from "app/popleads/hooks/useGetDealPaymentsByDealId";
import { Spinner } from "react-bootstrap";
import { publicTypes } from "../utils/constants";

const StyledTitle = styled(Heading4)`
    margin-bottom: 18px;
    color: ${colors.neutral[700]};
    display: block;
`;

const StyledItemContainer = styled("div")`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
`;

const StyledDisabledText = styled(Body2)`
    color: ${colors.neutral[600]};
`;

const StyledHorizontalLine = styled("div")`
    border-bottom: 1px solid ${colors.neutral[100]};
    margin-top: 12px;
    margin-bottom: 12px;
`;

const StyledAmountInfoContainer = styled("div")`
    display: flex;
    align-items: center;
    gap: 12px;
`;

const StyledAmount = styled(Body2)`
    color: ${colors.success[900]};
    font-weight: 500;
    max-width: 100%;
    font-size: 18px;
`;

const ButtonContiner = styled("div")`
    display: flex;
    align-items: center;
    gap: 20px;
`;

const ExtensionDealPayment = () => {
    const { selectedDeal, refetchProfile, setSelectedDealWithId, profile, isProfileLoading } = useExtensionContext();
    const { payments, getDealPayments, loading: getDealPaymentsLoading } = useGetDealPaymentsByDealId(selectedDeal?.id);

    const handleGetDealPayments = async () => {
        await getDealPayments();
        await refetchProfile();
    };

    useEffect(() => {
        setSelectedDealWithId(selectedDeal?.id);
    }, [profile]);

    return (
        <>
            <div style={{ position: "relative" }}>
                {(isProfileLoading || getDealPaymentsLoading) && (
                    <div
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(255, 255, 255, 0.7)",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 1,
                        }}
                    >
                        <Spinner animation="border" variant="primary" />
                    </div>
                )}
                <StyledTitle>Payment</StyledTitle>
                <StyledItemContainer>
                    <StyledDisabledText>VAT Included</StyledDisabledText>
                    {/*<Toggle size="small" selected={vatIncludes} options={options} disabled={true} />*/}
                    {selectedDeal?.vatIncludes === 1 && (
                        <ButtonWithText
                            icon="check"
                            iconType="feather"
                            variant="success"
                            size="circle"
                            buttonStyle="default"
                        />
                    )}
                    {selectedDeal?.vatIncludes === 0 && (
                        <ButtonWithText
                            icon="x"
                            iconType="feather"
                            variant="danger"
                            size="circle"
                            buttonStyle="default"
                        />
                    )}
                </StyledItemContainer>
                {publicTypes.includes(selectedDeal.dealCampaignType) && (
                    <StyledItemContainer>
                        <StyledDisabledText>Self Investment</StyledDisabledText>
                        {/*<Toggle size="small" selected={isSelfInvestment} options={options} disabled={true} />*/}
                        {selectedDeal?.isSelfInvestment === 1 && (
                            <ButtonWithText
                                icon="check"
                                iconType="feather"
                                variant="success"
                                size="circle"
                                buttonStyle="default"
                            />
                        )}
                        {selectedDeal?.isSelfInvestment === 0 && (
                            <ButtonWithText
                                icon="x"
                                iconType="feather"
                                variant="danger"
                                size="circle"
                                buttonStyle="default"
                            />
                        )}
                    </StyledItemContainer>
                )}
                <StyledItemContainer>
                    <StyledDisabledText>Paid</StyledDisabledText>
                    <ButtonContiner>
                        {selectedDeal?.paid === 1 && (
                            <ButtonWithText
                                icon="check"
                                iconType="feather"
                                variant="success"
                                size="circle"
                                buttonStyle="default"
                            />
                        )}
                        {selectedDeal?.paid === 0 && (
                            <ButtonWithText
                                icon="x"
                                iconType="feather"
                                variant="danger"
                                size="circle"
                                buttonStyle="default"
                            />
                        )}
                    </ButtonContiner>
                </StyledItemContainer>
                <ExtensionAddPayment getDealPayments={handleGetDealPayments} />
                <ExtensionPaymentList payments={payments} getDealPayments={handleGetDealPayments} />
                <StyledHorizontalLine />
                <StyledItemContainer>
                    <StyledDisabledText style={{ fontSize: "18px" }}>Total Paid</StyledDisabledText>
                    <StyledAmountInfoContainer>
                        <StyledAmount>
                            ${" "}
                            <FormattedNumber
                                minimumFractionDigits={0}
                                maximumFractionDigits={2}
                                value={selectedDeal?.paidAmount}
                            />
                        </StyledAmount>
                    </StyledAmountInfoContainer>
                </StyledItemContainer>
            </div>
        </>
    );
};

export default ExtensionDealPayment;
